export interface NoobookHeader
{
    'Content-Type'?: string | null;
    Authorization?: string | null;
    'X-Authorization'?: string | null;
    AccessAgent?: string | null;
}

export function genNoobookHeader(authToken?:string | null, refreshToken?:string | null, contentType?:string | null, accessAgent?:string | null):NoobookHeader
{
    var header:NoobookHeader = {};
    if(authToken)
    {
        header = {...header, "Authorization":`Bearer ${authToken}`};
    }
    if(refreshToken)
    {
        header = {...header, "X-Authorization":`Bearer ${refreshToken}`};
    }
    if(contentType)
    {
        header = {...header, "Content-Type":contentType};
    }
    if(accessAgent)
    {
        header = {...header, "AccessAgent":accessAgent};
    }
    return header;
}
